"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Widget = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var __1 = require("..");
var Divider_1 = require("../Divider");
var IconWrapper_1 = require("../Icon/IconWrapper");
require("./widget.css");
var Widget = function (props) {
    var renderActionButton = function (badgeButton, showLabel) { return ((0, jsx_runtime_1.jsx)(__1.Button, __assign({ arrowRight: true, type: "button", styleType: "info-grayish", onClick: badgeButton.action }, { children: showLabel && badgeButton.label ? badgeButton.label : '' }))); };
    var renderLinkButton = function (badgeButton, showLabel) { return ((0, jsx_runtime_1.jsx)(__1.Button, __assign({ arrowRight: true, type: "button", styleType: "info-grayish", link: badgeButton.link }, { children: showLabel ? badgeButton.label : '' }))); };
    var renderBadge = function (badge) {
        switch (badge.type) {
            case 'none':
                return null;
            case 'icon':
                return ((0, jsx_runtime_1.jsx)(IconWrapper_1.IconWrapper, __assign({ shape: "circle", backGroundColor: badge.theme, padding: 0.3, height: 1.5, width: 1.5 }, { children: (0, jsx_runtime_1.jsx)(__1.Icon, { icon: badge.icon, theme: "white", size: "lg" }) })));
            case 'action':
                return ((0, jsx_runtime_1.jsxs)(__1.FlexView, { children: [(0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 12, hides: ['xs', 'sm', 'hs', 'hm'] }, { children: renderActionButton(badge, true) })), (0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 12, hides: ['md', 'lg', 'xl'] }, { children: renderActionButton(badge, false) }))] }));
            case 'link':
                return ((0, jsx_runtime_1.jsxs)(__1.FlexView, { children: [(0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 12, hides: ['xs', 'sm', 'hs', 'hm'] }, { children: renderLinkButton(badge, true) })), (0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 12, hides: ['md', 'lg', 'xl'] }, { children: renderLinkButton(badge, false) }))] }));
            case 'custom':
                return badge.node;
        }
    };
    var renderSubtitle = function (subtitle) {
        if (typeof subtitle === 'undefined') {
            return null;
        }
        return (0, jsx_runtime_1.jsx)("div", __assign({ className: "widget_subtitle" }, { children: subtitle }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('widget-generic'), css: (0, react_1.css)(props.customStyle) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "widget_header" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "widget_header_title" }, { children: props.title })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "widget_header_badge" }, { children: renderBadge(props.badge) }))] })), (0, jsx_runtime_1.jsx)(Divider_1.Divider, { orientation: "horizontal", color: "light-grey" }), renderSubtitle(props.subtitle), (0, jsx_runtime_1.jsx)(__1.Spacer, { height: 0.4 }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "widget-generic-content" }, { children: props.children }))] })));
};
exports.Widget = Widget;
//# sourceMappingURL=Widget.js.map